import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Quicklink } from '@planone/bau365/data-access-newsfeed';
import { stringifyFilter } from '@planone/shared/util-interfaces';

@Component({
  selector: 'bau365-quicklinks',
  templateUrl: './quicklinks.component.html',
  styleUrls: ['./quicklinks.component.scss'],
})
export class QuicklinksComponent {
  @Input() quicklinks: Quicklink[] | undefined | null = [];
  @Input() fairId: string | undefined | null;

  @Output() clickQuicklink = new EventEmitter<string>();

  protected readonly stringifyFilter = stringifyFilter;

  onClick(e: Event) {
    const target = (e.target as any)?.href;
    if (!target) return;
    this.clickQuicklink.emit(target as string);
  }

  identifyQuicklink(index: number, chip: { id: string }) {
    return chip.id ?? index;
  }
}
